import { render, staticRenderFns } from "./EventJustificaionDetailsModal.vue?vue&type=template&id=ae878574&"
import script from "./EventJustificaionDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./EventJustificaionDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports